import React from "react";
import styled from "styled-components";

function Loader(props: any) {
  const { className = "", color } = props || {};
  return (
    <Span
      className={"spinner-border spinner-border-sm mr-1 " + className}
      color={color}
    />
  );
}

export default Loader;
const Span = styled.span`
  ${({ color }) => color && `color: ${color}`};
`;
